import React from "react";
import "./../styles/variable-projects.css";
import Projectsvariable from "../components/variable-projects";
import imagem1 from '../assets/images/Projetos/Rádios/radio.jpg';
import imagem2 from '../assets/images/Projetos/Rádios/radio-img2.jpg';
import imagem3 from '../assets/images/Projetos/Rádios/radio-img3.jpg';

const App = () => {
  const projectData = {
    date: "26/03/2018",
    title: "Rádios",
    images: [
     imagem1,
     imagem2,
     imagem3
    ],
    description:
      "Atendemos as principais Rádios do Estado de São Paulo, como, Mix fm, Jovem Pan, entre outras:",

    solutions: ["Sistema Irradiante", "Cabeamento para Estúdio"],
  };

  return <Projectsvariable {...projectData} />;
};

export default App;